import React from "react";
import "./Feature.css";
import { Col } from "react-bootstrap";

const Feature = ({ image, title, description }) => {
  return (
    <div className="feature">
      <img src={image} />
      <div className="feature-title">{title}</div>
      <div className="feature-des">{description}</div>
    </div>
  );
};

export default Feature;
